import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon, ListChecksIcon, PresentationIcon, UsersIcon } from 'lucide-react';
const includes = [{
  icon: SmartphoneIcon,
  title: '3 mini-negocios digitales',
  desc: 'Listos para ofrecer desde hoy mismo.'
}, {
  icon: ListChecksIcon,
  title: 'Paso a paso simple',
  desc: 'Instrucciones claras y sin lenguaje técnico.'
}, {
  icon: PresentationIcon,
  title: 'Ideas de presentación',
  desc: 'Aprende a mostrar tus servicios con seguridad.'
}, {
  icon: UsersIcon,
  title: 'Guía de clientes',
  desc: 'Estrategias para conseguir tus primeros clientes.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5
    }
  }
};
export function IncludesSection() {
  return <section className="bg-beige py-16 md:py-24" data-id="element-106">
      <div className="max-w-6xl mx-auto px-4" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-109">
            ¿Qué incluye IA Exprés 2026?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-110" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-111">
          {includes.map((item, index) => <motion.div key={index} variants={cardVariants} className="bg-white rounded-2xl p-8 text-center shadow-sm border border-cream hover:shadow-md transition-shadow" data-id="element-112">
              <div className="mx-auto w-16 h-16 bg-cream rounded-full flex items-center justify-center mb-6 text-gold" data-id="element-113">
                <item.icon className="w-8 h-8" data-id="element-114" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-115">{item.title}</h3>
              <p className="text-navy/70" data-id="element-116">{item.desc}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}